var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 23,
    viewBox: "0 0 33 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.515457H32.9357V22.5155H0V0.515457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.515457H32.9357V6.38213H0V0.515457ZM0 16.6488H32.9357V22.5155H0V16.6488Z",
    fill: "#D03433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.36926H32.9357V16.6617H0V6.36926Z",
    fill: "#FBCA46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4177 10.7821H12.8815V11.5155H11.4177V10.7821V10.7821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5394 12.9821C10.5394 13.4221 10.9786 13.7155 11.4177 13.7155C11.8568 13.7155 12.296 13.4221 12.296 12.9821L12.4424 10.7821H10.393L10.5394 12.9821V12.9821ZM9.66113 10.7821C9.66113 10.3421 9.95389 10.0488 10.2467 10.0488H12.4424C12.8815 10.0488 13.1743 10.3421 13.1743 10.6355V10.7821L13.0279 12.9821C12.8815 13.8621 12.296 14.4488 11.4177 14.4488C10.5394 14.4488 9.95389 13.8621 9.80751 12.9821L9.66113 10.7821Z",
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.95389 11.5155H12.8815V12.2488H12.1496L11.4177 13.7155L10.6858 12.2488H9.95389V11.5155V11.5155ZM7.75818 9.31546H9.22199V14.4488H7.75818V9.31546ZM13.6134 9.31546H15.0772V14.4488H13.6134V9.31546ZM9.95389 8.58213C9.95389 8.14213 10.2467 7.84879 10.6858 7.84879H12.1496C12.5887 7.84879 12.8815 8.14213 12.8815 8.58213V8.87546C12.8815 9.16879 12.7351 9.31546 12.4424 9.31546H10.2467C10.1003 9.31546 9.95389 9.16879 9.95389 9.02213V8.58213V8.58213Z",
    fill: "#A41517"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 22,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.fbc4102e333838fe1460822f6f5a302e.svg";
export { ForwardRef as ReactComponent };